import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"height":"100%"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, {
        style: _normalizeStyle({
        height: '30px',
        padding: '0px',
        width: _ctx.collapsed == true ? '40px' : '100%',
      })
      }, {
        default: _withCtx(() => [
          (_ctx.collapsed == true)
            ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                key: 0,
                class: "trigger",
                style: {"margin-top":"5px","margin-right":"10px","float":"right","font-size":"16px","color":"white"},
                onClick: _ctx.handleChangeMenu
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                key: 1,
                class: "trigger",
                onClick: _ctx.handleChangeMenu,
                style: {"margin-top":"5px","margin-right":"10px","float":"right","font-size":"16px","color":"white"}
              }, null, 8, ["onClick"]))
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}